/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overvieweventsloaderror3Inputs */

const en_overvieweventsloaderror3 = /** @type {(inputs: Overvieweventsloaderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The events couldn't be loaded.`)
};

const de_overvieweventsloaderror3 = /** @type {(inputs: Overvieweventsloaderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Events konnten nicht geladen werden.`)
};

/**
* | output |
* | --- |
* | "The events couldn't be loaded." |
*
* @param {Overvieweventsloaderror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const overvieweventsloaderror3 = /** @type {((inputs?: Overvieweventsloaderror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overvieweventsloaderror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_overvieweventsloaderror3(inputs)
	return de_overvieweventsloaderror3(inputs)
});
export { overvieweventsloaderror3 as "overviewEventsLoadError" }